module.exports = __webpack_public_path__ + "static/media/emoji_links.a529a0b5.svg";